export default "__VITE_ASSET__BBLs_vK5__"